import { useEffect, useState } from 'react';
import { GetRouteParcels, RerouteParcels, GetRoutesInSameTerritory } from '../../services/tpcPortalService';
import { useParams } from "react-router-dom";
import { RouteParcel, getStatusName } from "../../models/RouteParcel";
import RouteParcelView from './RouteParcelView';
import FullScreenOptionPicker from '../Common/FullScreenOptionPicker';
import RouteParcelsGridHeaders from './RouteParcelsGridHeaders';
import ReroutingParcelsView from './ReroutingParcelsView';
import Modal from '../Common/Modal';

function RouteParcelsView() {

    useEffect(() => { 
        getRouteParcels();
        setStatuses(["Green scans", "Red scans", "Yellow scans", "Inbound (blue)", "Non-Inbound (white)"]);
        setDisplayedStatuses(["Red scans", "Yellow scans", "Inbound (blue)", "Non-Inbound (white)"]);
        getRoutesInTerritory();
    }
    ,[])

    const params = useParams();

    const [routeParcels, setRouteParcels] = useState<RouteParcel[]>([]);

    const [statuses, setStatuses] = useState<string[]>([]);
    const [displayedStatuses, setDisplayedStatuses] = useState<string[]>([]);

    const [newRouteChoices, setNewRouteChoices] = useState<string[]>([]);
    const [newRoute, setNewRoute] = useState<string>("");

    const [currentProcess, setCurrentProcess] = useState<string>("");

    const [messages, setMessages] = useState<string[]>([]);

    const getRouteParcels = async () => {
        const newRouteParcels = await GetRouteParcels(params.routeNumber ?? "");
        setRouteParcels(newRouteParcels);
    }

    const getRoutesInTerritory = async () => {
        const getRoutesInTerritory = await GetRoutesInSameTerritory(params.routeNumber ?? "");
        setNewRouteChoices(getRoutesInTerritory);
    }

    const displayedStatusChanged = (status: string) =>
    {
        if(!displayedStatuses.includes(status))
            setDisplayedStatuses([...displayedStatuses, status])
        else
            setDisplayedStatuses(displayedStatuses.filter(s => s !== status));
    }

    const newRouteSelected = (selectedRoute: string) => 
    {
        setNewRoute(selectedRoute);
        setCurrentProcess("rerouting");
    }

    const handleRerouteConfirmed = async (parcels: RouteParcel[]) => {
        let result = await RerouteParcels(newRoute, parcels);
        if(result.reroutedParcels.length > 0)
            setMessages([...messages, "Rerouted " + result.reroutedParcels.length + " parcels to Route " + result.newRouteNumber]);
        else
            setMessages([...messages, result.errors[0]]);
        setCurrentProcess("");

        await getRouteParcels();
    }

    const handleParcelSelected = (parcel: RouteParcel) => {
        setRouteParcels(routeParcels.map(rp => {
            if(rp.controlNumber === parcel.controlNumber)
                return parcel;
            
            return rp;
        }));
    }

    return (
        <div className="text-sm sm:text-1xl md:text-1xl lg:text-2xl xl:text-2xl">

            {messages.length > 0 &&
                DisplayMessage()}

            {currentProcess === "rerouting" && 
                GetReroutingScreen()}

            {currentProcess !== "rerouting" &&
                <div className="grid grid-cols-12 text-center text-black">
                    <div className="col-span-12 cursor-pointer hover:bg-blue-400" onClick={() => setCurrentProcess("scanFilter")}>Displaying: {displayedStatuses.join(', ')}</div>
                </div>}

            {currentProcess === "" && 
                <div>
                    <div className="grid grid-cols-12 text-center text-black">
                        <RouteParcelsGridHeaders></RouteParcelsGridHeaders>
                        <ul className="col-span-12">
                            <div>
                            {routeParcels.filter(rp => displayedStatuses.includes(getStatusName(rp.parcelStatus))).map((rp) =>
                                <RouteParcelView key={rp.controlNumber !== 0 ? rp.controlNumber : rp.accountNumber.toString() + rp.trackingNumber} routeParcel={rp} onSelected={handleParcelSelected}/>
                            )}
                            </div>
                        </ul>
                    </div>
                    
                    <footer className="border-t-2 border-black grid grid-cols-12 sticky bottom-0 p-2 bg-tpc-portal-banner-dark h-12">
                        {routeParcels.filter(rp => rp.selected).length > 0 && 
                            <div className="cursor-pointer border-2 border-black text-center col-end-13 col-span-2 bg-gls-logo-blue text-gls-logo-yellow p-2" onClick={() => setCurrentProcess("selectNewRoute")}>Reroute</div>}
                    </footer>
                </div>}

            {currentProcess !== "" && 
                GetFullScreenDisplay(currentProcess) }

        </div>
    );

    function DisplayMessage(){
        return (
            <Modal text={messages[0]} timeout={5000} onClose={() => setMessages(messages.filter(m => m !== messages[0]))}></Modal>
        )
    }

    function GetReroutingScreen(){
        return(
            <ReroutingParcelsView onConfirm={handleRerouteConfirmed} newRouteNumber={newRoute} routeParcels={routeParcels.filter(rp => rp.selected)}></ReroutingParcelsView>
        )
    }

    function GetFullScreenDisplay(openMenu: string){

        switch(openMenu)
        {
            case "scanFilter":
                return( 
                    <div className="text-center">
                        {
                            <FullScreenOptionPicker 
                                title="Select Parcels to Display"
                                className="bg-gray-200 cursor-pointer"
                                options={statuses}
                                optionsClassName="bg-gray-300 hover:bg-blue-400 py-2"
                                onSelected={displayedStatusChanged}
                                cancelText="Done"
                                onCancel={() => setCurrentProcess("")}
                            ></FullScreenOptionPicker>
                        }
                    </div> 
                );
            case "selectNewRoute":
                return( 
                    <div className="text-center">
                        {
                            <FullScreenOptionPicker 
                                title="Select New Route"
                                className="bg-gray-200 cursor-pointer"
                                options={newRouteChoices}
                                optionsClassName="bg-gray-300 hover:bg-blue-400 py-2"
                                onSelected={newRouteSelected}
                                cancelText="Done"
                                onCancel={() => setCurrentProcess("")}
                            ></FullScreenOptionPicker>
                        }
                    </div> 
                );
        }
    }

}

export default RouteParcelsView;